import Big from "big.js"
import toFormat from "toformat"

Big.strict = true
export default toFormat(Big)
